import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import CompAppHeader from './Components/CompAppHeader';
import uxiBg from './Assets/Images/uxi-bg.png';
import Home from './Pages/Home';
import About from './Pages/About';
import StartupsAndProducts from './Pages/StartupsAndProducts';
//import Consulting from './Pages/Consulting';
import Contact from './Pages/Contact';
import CompPageTemplateCommon from './Components/CompPageTemplateCommon';
import UXaaS from './Pages/UXaaS';
import ContentfulArticlePage from './Pages/ContentfulArticlePage'; // Import the updated Contentful page
import CXMainStreet from './Pages/CXMainStreet'; // Import the CXMainStreet page
import InnovationEngine from './Pages/InnovationEngine';
import ContentfulWebinarPage from './Pages/ContentfulWebinarPage'; // Import the Contentful Webinar page

function App() {
  return (
    <Router>
      <div className="App" style={{ 
        backgroundImage: `url(${uxiBg})`, 
        backgroundSize: 'cover', 
        minHeight: '100vh', 
        backgroundRepeat: 'no-repeat' 
      }}>
        <CompAppHeader />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<CompPageTemplateCommon><About /></CompPageTemplateCommon>} />
          <Route path="/startups-and-products" element={<CompPageTemplateCommon><StartupsAndProducts /></CompPageTemplateCommon>} />
          {/*<Route path="/consulting" element={<CompPageTemplateCommon><Consulting /></CompPageTemplateCommon>} />*/}
          <Route path="/contact" element={<CompPageTemplateCommon><Contact /></CompPageTemplateCommon>} />
          <Route path="/ux-as-a-service" element={<CompPageTemplateCommon><UXaaS /></CompPageTemplateCommon>} />
          <Route path="/article/:slug" element={<CompPageTemplateCommon><ContentfulArticlePage /></CompPageTemplateCommon>} />
          <Route path="/webinar/:slug" element={<CompPageTemplateCommon><ContentfulWebinarPage /></CompPageTemplateCommon>} />
          <Route path="/cx-main-street" element={<CompPageTemplateCommon><CXMainStreet /></CompPageTemplateCommon>} />
          <Route path="/innovation-engine" element={<CompPageTemplateCommon><InnovationEngine /></CompPageTemplateCommon>} />
          {/* Add more routes as needed */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
